import React from 'react';
import { FileText } from 'lucide-react';

const Terms = () => {
  return (
    <div className="min-h-screen text-white pt-20 md:pt-32">
      {/* Hero Section - Adapté pour mobile */}
      <div className="container mx-auto px-4 mb-8 md:mb-16">
        <div className="max-w-3xl mx-auto text-center">
          <div className="w-12 h-12 md:w-16 md:h-16 rounded-xl bg-[#017D7E]/10 flex items-center justify-center mx-auto mb-4 md:mb-6">
            <FileText className="w-6 h-6 md:w-8 md:h-8 text-[#017D7E]" />
          </div>
          <h1 className="text-3xl md:text-5xl font-bold mb-4 md:mb-6">
            Conditions Générales d'Utilisation
          </h1>
          <p className="text-base md:text-xl text-white/70">
            Dernière mise à jour : 15 décembre 2024
          </p>
        </div>
      </div>

      {/* Content - Adapté pour mobile */}
      <div className="container mx-auto px-4 mb-8 md:mb-16">
        <div className="max-w-3xl mx-auto prose prose-invert">
          <div className="bg-white/5 rounded-xl p-4 md:p-8 border border-white/10 space-y-6 md:space-y-8">
            <section>
              <h2 className="text-xl md:text-2xl font-semibold mb-3 md:mb-4">1. Introduction</h2>
              <p className="text-sm md:text-base text-white/70">
                Les présentes Conditions Générales d'Utilisation régissent l'utilisation des services fournis par KG Technologies. En utilisant nos services, vous acceptez d'être lié par ces conditions.
              </p>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-semibold mb-3 md:mb-4">2. Services</h2>
              <p className="text-sm md:text-base text-white/70 mb-3 md:mb-4">
                KG Technologies fournit des solutions technologiques pour le secteur financier, incluant mais ne se limitant pas à :
              </p>
              <ul className="list-disc pl-4 md:pl-6 space-y-1 md:space-y-2 text-sm md:text-base text-white/70">
                <li>Plateformes de gestion financière</li>
                <li>Solutions d'analyse de données</li>
                <li>Services de conseil et d'intégration</li>
                <li>Support technique et maintenance</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-semibold mb-3 md:mb-4">3. Licence d'Utilisation</h2>
              <p className="text-sm md:text-base text-white/70">
                KG Technologies vous accorde une licence non exclusive, non transférable et révocable pour utiliser nos services conformément à ces conditions et aux termes spécifiques de votre contrat.
              </p>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-semibold mb-3 md:mb-4">4. Propriété Intellectuelle</h2>
              <p className="text-sm md:text-base text-white/70">
                Tous les droits de propriété intellectuelle liés à nos services, y compris les logiciels, marques, logos et documentation, restent la propriété exclusive de KG Technologies ou de ses concédants de licence.
              </p>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-semibold mb-3 md:mb-4">5. Responsabilités</h2>
              <p className="text-sm md:text-base text-white/70">
                KG Technologies s'engage à fournir ses services avec diligence et conformément aux standards de l'industrie. Notre responsabilité est limitée aux conditions spécifiées dans votre contrat de service.
              </p>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-semibold mb-3 md:mb-4">6. Confidentialité</h2>
              <p className="text-sm md:text-base text-white/70">
                Les parties s'engagent à maintenir la confidentialité des informations échangées dans le cadre des services. Pour plus de détails, veuillez consulter notre politique de confidentialité.
              </p>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-semibold mb-3 md:mb-4">7. Résiliation</h2>
              <p className="text-sm md:text-base text-white/70">
                Les conditions de résiliation sont spécifiées dans votre contrat de service. KG Technologies se réserve le droit de suspendre ou résilier l'accès aux services en cas de violation des présentes conditions.
              </p>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-semibold mb-3 md:mb-4">8. Modifications</h2>
              <p className="text-sm md:text-base text-white/70">
                KG Technologies se réserve le droit de modifier ces conditions à tout moment. Les modifications entrent en vigueur dès leur publication. Les utilisateurs seront informés des changements significatifs.
              </p>
            </section>

         

       
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;